import { FiAlertTriangle } from "react-icons/fi";
import "./form-error.style.scss";

interface FormErrorProps {
	isError?: boolean;
	error?: unknown;
	fallback?: string;
}

// Inline replacement for showToastMessage(msg, "E") on TanStack Query mutations
// (see src/global/query-client.ts) — pass a mutation's own isError/error state directly.
export default function FormError({ isError, error, fallback = "Something went wrong." }: FormErrorProps) {
	if (!isError) return null;

	const message = error instanceof Error ? error.message : fallback;

	return (
		<div className="form-error">
			<FiAlertTriangle size={16} aria-hidden="true" />
			<p>{message}</p>
		</div>
	);
}
